const allowedTags = new Set(['B', 'STRONG', 'I', 'EM', 'U', 'DIV', 'P', 'BR']);

export function sanitizeHtml(input: string): string {
  const template = document.createElement('template');
  template.innerHTML = input;

  const walk = (node: Node) => {
    [...node.childNodes].forEach((child) => {
      if (child.nodeType === Node.ELEMENT_NODE) {
        const element = child as HTMLElement;
        if (!allowedTags.has(element.tagName)) {
          element.replaceWith(document.createTextNode(element.textContent ?? ''));
          return;
        }
        [...element.attributes].forEach((attribute) => element.removeAttribute(attribute.name));
      }
      walk(child);
    });
  };

  walk(template.content);
  return template.innerHTML;
}
